// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { baseUrl } from "../../boot/index";
// import axios from "axios";

// // get Task 
// export const getTaskMaster = createAsyncThunk("getlist-taskmaster", async (data) => {
// console.log("data in task master redux api", data)
//     const token = localStorage.getItem("authToken")
//     try {
//         const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/getlist-taskmaster`, data, { 
//             headers: {
//                 "auth-token": token,
//             }
//         },);
//         console.log({'respppppppppppppptaskMasterredux' :response })
//         return response;
//     } catch (error) {
//         console.error('Error fetching Sites - ', error);
//         throw error;
//     }
// })


import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Task 
export const getTaskMaster = createAsyncThunk("getlist-taskmaster", async (data) => {
    console.log("data in task master redux api", data);
    
    const token = localStorage.getItem("authToken");
    const departmentName = localStorage.getItem("departmentName");
    const isRestrictedDepartment = 
        departmentName === "TELE SALES" || 
        departmentName === "Field Sale" || 
        departmentName === "Senior Telesales";

    try {
        // Check for saved search query
        const savedTaskMasterSearchQuery = sessionStorage.getItem("taskMasterSearchQuery");
        
        let finalPayload = { ...data };

        // Apply restrictions at API level
        if (!savedTaskMasterSearchQuery && isRestrictedDepartment) {
            finalPayload = {
                ...finalPayload,
                search: [
                    ...(finalPayload.search || []),
                    {
                        field: "masterModule",
                        operation: "is",
                        value: "leads"
                    }
                ]
            };
        }

        console.log("Final API Payload:", finalPayload);

        const response = await axios.post(
            `${baseUrl}cleaningappfunctions/crm/app/v1/getlist-taskmaster`, 
            finalPayload, 
            { 
                headers: {
                    "auth-token": token,
                }
            }
        );
        
        console.log({'respppppppppppppptaskMasterredux': response});
        return response;
    } catch (error) {
        console.error('Error fetching Sites - ', error);
        throw error;
    }
});